<template>
    <v-container fill-height>
      <v-row justify="center" align="center">
        <v-col cols="12" md="10">
            <v-card elevation="3" class="pa-4 custom-card">
            <v-card-title class="headline text-center">공지사항 작성</v-card-title>
            <v-divider class="mb-4"></v-divider>

            <!-- ✅ 제목 입력 -->
            <v-text-field
              v-model="notice_title"
              label="공지 제목"
              outlined
              dense
              class="mb-4"
            />

            <!-- ✅ 본문 에디터 (TinyMCE) -->
            <tiny-editor v-model="notice_message" upload-prefix="carrygold/notice/images/" class="mb-4" />

            <v-divider class="mb-4"></v-divider>

            <v-row justify="end">
              <v-spacer></v-spacer>
              <v-btn color="secondary" class="mr-2" @click="CancelEdit">취소</v-btn>
              <v-btn color="primary" @click="OnSave_EditingData">작성 완료</v-btn>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>

  <script>
  import { mapActions } from 'vuex';
  import TinyEditor from '../common/TinyEditor.vue';

  export default {
    components: {
      TinyEditor,
    },
    data() {
      return {
        notice_data:null,
        notice_title: "",
        notice_message: "",
      };
    },

    mounted() {
        //GET_NOTICE_INFO
        let pid = this.$route.query.pid;
        if(pid != undefined)
        {
            this.CARRYGOLD_GET_NOTICE_INFO({ pid }).then((body_data)=>{
            console.log(JSON.stringify(body_data));
                let result_data = body_data.result_data;
                this.notice_data = body_data.result_data;
                this.notice_title = result_data.TITLE;
                this.notice_message = result_data.MESSAGE || "";
            })
            .catch((err) => {
                console.log(err);
            })
        }
    },
    methods: {
        ...mapActions([
            'CARRYGOLD_CREATE_NOTICE',
            'CARRYGOLD_GET_NOTICE_LIST',
            'CARRYGOLD_SET_NOTICE_INFO',
            'CARRYGOLD_GET_NOTICE_INFO'
        ]),

      CancelEdit() {
        this.$router.push(`/carrygold_notice`);
      },

      OnSave_EditingData() {
        console.log("제목:", this.notice_title);
        console.log("내용:", this.notice_message);
        let notice_title = this.notice_title;
        let notice_message = this.notice_message;
        if(this.$route.query.pid === undefined) {
            console.log("작성");
            this.CARRYGOLD_CREATE_NOTICE({notice_title, notice_message }).then((body_data)=>{
                    this.loadingData = false;
                    alert("등록 완료");
                    this.$router.push(`/carrygold_notice`);
                })
                .catch((err) => {
                    console.log(err);
                })
          }
        else{//여기는 수정이다.
            console.log("수정");
            const  pid = this.$route.query.pid;
            // notice_data가 없거나 ENABLE_YN이 없을 경우 기본값 'Y' 사용
            const enable_yn = (this.notice_data && this.notice_data.ENABLE_YN) ? this.notice_data.ENABLE_YN : 'Y';
            this.CARRYGOLD_SET_NOTICE_INFO({notice_title, notice_message, enable_yn, pid  }).then((body_data)=>{
                this.loadingData = false;
                alert('수정완료.');
                this.$router.push(`/carrygold_notice`);
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        }
      }
    }
  };
  </script>

  <style scoped>
  /* ✅ 카드 중앙 정렬 */
  .v-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
  }

  /* ✅ 카드 스타일 */
  .custom-card {
    max-width: 900px;
    margin-top: 30px;
  }

  @media (max-width: 600px) {
    .custom-card {
      max-width: 100% !important;
      margin-top: 10px;
    }
  }
  </style>
